import Vue from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  render: (h) => h(App),
  created() {
    AOS.init();
  },
}).$mount("#app");
